import $ from "jquery";
import { capitalize } from "lodash";
import { MORPH_DATA, state } from "../../core/settings";
import { summaryButtonComponent } from "../summary/summary-button/summaryButton";
import interfaceHTML from "./interface.html";
import "./interface.scss";
import { interfaceGroupComponent } from "./interfaceItems/interfaceGroup/interfacGroup";
import {
  interfaceGroupInputsComponent,
  typesInputs,
  updateTextParam,
} from "./../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import { typesDirection } from "./interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange";

export const step = !state.model ? 17 : 20;

const textWall = updateTextParam(state, this, false, true);
const textElectro = updateTextParam(state, this, true, true);
const textSub = updateTextParam(state, this, false, true, true);

export function deleteActiveClassFromContainerRadioType(
  container,
  firstSelector,
  activeClass
) {
  container.find(firstSelector).each(function () {
    $(this).closest(firstSelector).removeClass(activeClass);
  });
}

export const stringRoofType = {
  0: "Opening Roof",
  1: "Retractable Opening Roof",
};

// Opening Roof (roofType 0) 
export const louvreTypesOpening = {
  0: "180/30 Slimline Roof",
  1: "200/35 Slimline Roof",
  2: "200 Suburban Roof",
  3: "220/35 Slimline Roof",
  4: "220/45 Alpine Roof",
  5: "270 Translucent Roof",
};
// Retractable Opening Roof (roofType 1) 
export const louvreTypesRetractable = {
  0: "220/35 Slimline Retract",
  1: "220/45 Alpine Retract",
};


export const louvreMeshNames = {
  // Opening Roof 
  "opening_0": { x: "18030_Slimline_Roof_x", y: "18030_Slimline_Roof_y" },
  "opening_1": { x: "20035_Slimline_Roof_x", y: "20035_Slimline_Roof_y" },
  "opening_2": { x: "200_Suburban_Roof_x", y: "200_Suburban_Roof_y" },
  "opening_3": { x: "22035_Slimline_Roof_x", y: "22035_Slimline_Roof_y" },
  "opening_4": { x: "22045_Alpine_Roof_x", y: "22045_Alpine_Roof_y" },
  "opening_5": { x: "270_Translucent_Roof_x", y: "270_Translucent_Roof_y" },
  // Retractable
  "retractable_0": { x: "22035_Slimline_Retract_Roof_x", y: "22035_Slimline_Retract_Roof_y" },
  "retractable_1": { x: "22045_Alpine_Retract_Roof_x", y: "22045_Alpine_Retract_Roof_y" },
};

export function getLouvreTypes() {
  return state.roofType === 0 ? louvreTypesOpening : louvreTypesRetractable;
}

export const stringPostSize = {
  0: `100 x 100`,
  1: `150 x 150`
};

export const groups = [
  { title: "SET UP", param: textWall, type: typesInputs.selectButton },
  {
    title: "ROOF TYPE",
    param: stringRoofType[state.roofType],
    type: typesInputs.roofType,
  },
  {
    title: "LOUVRE TYPE",
    param: getLouvreTypes()[state.louvreType],
    type: typesInputs.louvreType,
  },
  {
    title: "ROOF DIMENSIONS",
    param: `${state.length}m x ${state.width}m x ${state.height}m`,
    type: typesInputs.range,
    ranges: [
      {
        title: "Louvre Span (m)",
        labelMin: `1`,
        labelMax: `5`,
        min: MORPH_DATA.length.min,
        max: MORPH_DATA.length.max,
        step: 0.1,
        thumb: true,
        initialValue: state.length,
        showLabels: true,
        showSwitchAngle: false,
        inch: true,
      },
      {
        title: "Pivot (m)",
        labelMin: `1`,
        labelMax: `12`,
        min: MORPH_DATA.width.min,
        max: MORPH_DATA.width.max,
        step: 0.1,
        thumb: true,
        initialValue: state.width,
        showLabels: true,
        showSwitchAngle: false,
        inch: true,
      },
      {
        title: "Height (m)",
        labelMin: `1.0`,
        labelMax: `3.5`,
        min: MORPH_DATA.height.min,
        max: MORPH_DATA.height.max,
        step: 0.5,
        thumb: true,
        initialValue: state.height,
        showLabels: true,
        showSwitchAngle: false,
        inch: true,
      },
    ],
  },
  {
    title: "POST SIZE",
    param: stringPostSize[state.postSize],
    type: typesInputs.postSize,
    initValuePostSize: state.postSize,
  },
  {
    title: "ROOF COLOR", 
    param: state.colorRoof,
    type: typesInputs.colorLouvre,
  },
  {
    title: "FRAME COLOR",
    param: state.colorBody,
    type: typesInputs.colorFrame,
  },
  { title: "SIDE INFILL OPTIONS", param: textSub, type: typesInputs.subSystem },
  {
    title: "HEATING | LIGHTING",
    param: textElectro,
    type: typesInputs.electronic,
  },
];

export function interfaceComponent(container) {
  const componentContent = $(
    '<div class="interface-container" id="interface"></div>'
  );

  const interfaceElement = $(interfaceHTML);

  groups.forEach((group) => {
    const groupComponent = interfaceGroupComponent(group.title, group.param);
    const groupComponentInputs = $(
      '<div class="interface__group__inputs"></div>'
    );
    groupComponentInputs.append(
      interfaceGroupInputsComponent(
        group.type,
        group?.ranges,
        group?.initValuePostSize,
        group.title
      )
    );
    groupComponent.append(groupComponentInputs);

    groupComponentInputs.hide();

    interfaceElement.append(groupComponent);
  });

  $(componentContent).append(interfaceElement);

  summaryButtonComponent(componentContent);
  $(container).append(componentContent);
}
